import axios from "axios";
import Cookies from "js-cookie";

import { API_BASE_URL } from "./apiBaseUrl";

const axiosInstance = axios.create({
  baseURL: `${API_BASE_URL}/`,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const clearAuthData = () => {
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");
  Cookies.remove("auth_role");
  Cookies.remove("user_id");
  Cookies.remove("student_id");
  Cookies.remove("email");
  Cookies.remove("first_name");
  Cookies.remove("last_name");
  localStorage.removeItem("isAuthenticated");
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = Cookies.get("refresh_token");
      if (!refreshToken) {
        clearAuthData();
        window.location.href = "/login";
        return Promise.reject(error);
      }

      try {
        const role = Cookies.get("auth_role");
        const refreshEndpoint = role === "student"
          ? `${API_BASE_URL}/student-auth/token/refresh/`
          : `${API_BASE_URL}/auth/token/refresh/`;
        const { data } = await axios.post(refreshEndpoint, { refresh: refreshToken });
        Cookies.set("access_token", data.access, {
          sameSite: "Lax",
          secure: window.location.protocol === "https:",
        });
        originalRequest.headers.Authorization = `Bearer ${data.access}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        clearAuthData();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
